module.exports = __webpack_public_path__ + "img/5.da5f168b.jpg";